<div id="app-wrapper">
  <div class="toast-container position-fixed bottom-0 end-0 p-3" style="z-index: 1200">
    <div *ngFor="let toast of toastService.toasts; let i = index">
      <ngb-toast [class]="toast.style"
                 [autohide]="true"
                 [delay]="toast.delay || 5000"
                 (hidden)="toastService.remove(i)">
        {{ toast.message }}
      </ngb-toast>
    </div>
  </div>
  <router-outlet></router-outlet>
  <span id="app-status">{{ appStatus }}</span>
  <span id="app-version">{{ appVersion }}</span>
</div>